import { render, staticRenderFns } from "./SurveyPreview.vue?vue&type=template&id=0130b012&scoped=true&"
import script from "./SurveyPreview.vue?vue&type=script&lang=js&"
export * from "./SurveyPreview.vue?vue&type=script&lang=js&"
import style0 from "./SurveyPreview.vue?vue&type=style&index=0&id=0130b012&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0130b012",
  null
  
)

export default component.exports